import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react-lite";
import { Colors } from "../../../../../theme";
import { useEffect, useState } from "react";
import moment from "moment";

interface RepeatTypeProps {
  open: boolean;
  onConfirmDelete?: (selectedOption: number) => void;
  onClose?: () => void;
  time: number;
  endTime: number;
  repeat: boolean;
}

const RepeatTypeModal: React.FC<RepeatTypeProps> = observer(
  ({ open, onClose, time, endTime, repeat, onConfirmDelete }) => {
    const [selectedValue, setSelectedValue] = useState<string>("option2");

    useEffect(() => {
      setSelectedValue("option2");
    }, [open]);

    const handleClose = () => {
      if (onConfirmDelete) {
        const selectedOption =
          selectedValue === "option1" ? 0 : selectedValue === "option2" ? 1 : 2;
        onConfirmDelete(selectedOption);
      }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedValue((event.target as HTMLInputElement).value);
    };

    return (
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            backgroundColor: "white",
            borderRadius: "4px",
            boxShadow: 24,
            width: "500px",
            maxHeight: "80vh",
            transform: "translate(-50%, -50%)",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              height: "40px",
              backgroundColor: "#08B0A0",
              display: "flex",
              alignItems: "center",
              borderRadius: "4px 4px 0 0",
              justifyContent: "space-between",
            }}
          >
            <Typography
              color={Colors.white}
              sx={{ paddingLeft: "16px" }}
              variant="h5"
            >
              CONFIRMATION
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ color: "white", width: 24, height: 24 }} />
            </IconButton>
          </Box>

          {/* Content */}
          <Box
            sx={{
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingBottom: "20px",
              overflowY: "auto",
              maxHeight: "calc(80vh - 40px)",
              marginTop: "8px",
            }}
          >
            {repeat && (
              <FormControl component="fieldset" style={{ marginTop: "16px" }}>
                <RadioGroup
                  aria-label="repeat-type"
                  name="repeat-type"
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="option1"
                    control={<Radio />}
                    label="All checklists"
                  />
                  <FormControlLabel
                    value="option2"
                    control={<Radio />}
                    label={`This checklist (${moment
                      .unix(time ?? 0)
                      .format("DD/MM/YYYY")})`}
                    style={{ marginTop: "8px" }}
                  />
                  <FormControlLabel
                    value="option3"
                    control={<Radio />}
                    label={`This and following checklist (${moment
                      .unix(time ?? 0)
                      .format("DD/MM/YYYY")} - ${moment
                      .unix(endTime ?? 0)
                      .format("DD/MM/YYYY")})`}
                    style={{ marginTop: "8px" }}
                  />
                </RadioGroup>
              </FormControl>
            )}
            {!repeat && (
              <Typography style={{ fontSize: "16px", marginTop: "16px" }}>
                Are you sure you want to delete this checklist?
              </Typography>
            )}
          </Box>

          {/* Footer Buttons */}
          <Box
            sx={{
              justifyContent: "flex-end",
              display: "flex",
              marginTop: "40px",
              paddingRight: "20px",
              paddingBottom: "20px",
              flexDirection: "row",
              gap: "20px",
            }}
          >
            <Button
              variant="outlined"
              style={{
                color: "gray",
                borderColor: "gray",
                fontSize: "13px",
                maxHeight: "36px",
              }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{ fontSize: "13px", maxHeight: "36px" }}
              onClick={handleClose}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  }
);

export default RepeatTypeModal;
